"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _pageNotFound = _interopRequireDefault(require("../../../assets/images/pageNotFound.png"));
var _components = require("../../../components");
var _PageNotFoundModule = _interopRequireDefault(require("./PageNotFound.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PageNotFound = _ref => {
  let {
    handleGoToHome
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    className: _PageNotFoundModule.default.pageNotFoundContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    className: _PageNotFoundModule.default.mediaContentContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    className: _PageNotFoundModule.default.mediaContiner
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _pageNotFound.default,
    title: "Page Not Found",
    alt: "Page not found"
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    className: _PageNotFoundModule.default.contentContainer
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3"
  }, "Page not found!"), /*#__PURE__*/_react.default.createElement(_Typography.default, null, "The page that you are trying to access is moved, currently down or never existed. Please check the URL."), /*#__PURE__*/_react.default.createElement(_components.SNETButton, {
    variant: "outlined",
    onClick: handleGoToHome
  }, "go to home"))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    className: _PageNotFoundModule.default.description
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "If you are seeing this message repeatedly, let us know at", " ", /*#__PURE__*/_react.default.createElement(_components.AnchorLink, {
    label: "support@singularitynet.io",
    href: "/"
  }), " and we will look into it.")));
};
PageNotFound.propTypes = {
  handleGoToHome: _propTypes.default.func
};
var _default = exports.default = PageNotFound;